import {Theme} from '@mui/material/styles';

export default function DialogTitle(theme: Theme) {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '24px',
          lineHeight: '28px',
          padding: '32px 32px 16px',
          [theme.breakpoints.down('sm')]: {
            padding: '48px 24px 8px 24px',
          },
        },
      },
    },
  };
}
